const adminRoutes = [
  {
    path: '/admin',
    name: 'AdminHome',
    component: () => import('@/views/Admin/Home'),
    meta: { auth: true }
  },
  {
    path: '/admin/contact',
    name: 'AdminContact',
    component: () => import('@/views/Admin/Contact'),
    meta: { auth: true }
  }
    // {
    //   path: '/advertise',
    //   component: () => import('@/views/advertise/index'),
    //   meta: { auth: true }
    // },
    // {
    //   path: '/video',
    //   component: () => import('@/views/video/index'),
    //   meta: { auth: true }
    // },
    // {
    //   path: '/news',
    //   component: () => import('@/views/news/index'),
    //   meta: { auth: true }
    // },
    // {
    //   path: '/record',
    //   component: () => import('@/views/record/index'),
    //   meta: { auth: true }
    // },
    // {
    //   path: '/deposit',
    //   component: () => import('@/views/deposit/index'),
    //   meta: { auth: true }
    // },
    // {
    //   path: '/partner',
    //   component: () => import('@/views/partner/index'),
    //   meta: { auth: true }
    // },
    // {
    //   path: '/faq',
    //   component: () => import('@/views/faq/index'),
    //   meta: { auth: true }
    // }
]

export default adminRoutes
